"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.responsiveStyles = void 0;

var _utils = require("../utils");

var _constants = require("./constants");

var _interfaces = require("./interfaces");

var responsiveStyles = function responsiveStyles(_ref, theme) {
  var iconOnly = _ref.iconOnly,
      shouldUseResponsiveContent = _ref.shouldUseResponsiveContent,
      size = _ref.size,
      variant = _ref.variant;
  var selectors = theme.selectors;
  var isSmall = size === _interfaces.ButtonSize.Small;
  var isTertiary = variant === _interfaces.ButtonVariant.Tertiary;

  var getPaddingValues = function getPaddingValues(fontSize, lineHeight) {
    if (iconOnly) {
      return "".concat((_utils.A11Y_MIN_SIZE - (isSmall ? _utils.DEFAULT_ICON_SIZE : _utils.DEFAULT_S_ICON_SIZE)) / 2 - _constants.BORDER_WIDTH - (isSmall ? (_utils.DEFAULT_ICON_SIZE - _utils.DEFAULT_S_ICON_SIZE) / 2 : 0), "px");
    }

    var verticalPadding;
    var horizontalPadding = isSmall || isTertiary ? 16 : 24;

    if (isSmall) {
      verticalPadding = (0, _utils.getAccessibilityPadding)(lineHeight, fontSize) - _constants.BORDER_WIDTH * 2;
    } else {
      var contentHeight = !fontSize ? _utils.EM_TO_PX_RATIO * _utils.DEFAULT_LINE_HEIGHT : (0, _utils.getContentHeight)(lineHeight, fontSize);
      verticalPadding = Math.ceil((_constants.REGULAR_BUTTON_HEIGHT - _constants.BORDER_WIDTH * 2 - contentHeight) / 2);
    }

    return "".concat(verticalPadding, "px ").concat(horizontalPadding, "px");
  };

  var fontSizeKey = isSmall ? 'T100' : 'T200';
  var fontSize = selectors.fontSize(fontSizeKey);
  var lineHeight = selectors.lineHeight(fontSizeKey);
  var defaultMediaParamsStyles = {
    fontSize: fontSize,
    lineHeight: lineHeight,
    padding: getPaddingValues(fontSize, lineHeight)
  };
  var mediaParamsStyles = {};

  if (shouldUseResponsiveContent && theme.shouldUseResponsiveText) {
    var breakpoints = theme.values.breakpoint;
    Object.keys(breakpoints).forEach(function (bp) {
      var breakpoint = bp; // using buildMediaQuery here breaks Button import in ButtonTrigger for several legacy tests

      var mediaQuery = '';
      var breakpointValues = breakpoints[breakpoint];

      if (breakpointValues.hasOwnProperty('max')) {
        mediaQuery += " and (max-width: ".concat(breakpointValues.max, "px)");
      }

      if (breakpointValues.hasOwnProperty('min')) {
        mediaQuery += " and (min-width: ".concat(breakpointValues.min, "px)");
      }

      if (mediaQuery.length > 0) {
        var bpFontSize = selectors.fontSize(fontSizeKey, {
          breakpoint: breakpoint
        });
        var bpLineHeight = selectors.lineHeight(fontSizeKey, {
          breakpoint: breakpoint
        });
        mediaParamsStyles["@media screen ".concat(mediaQuery)] = {
          fontSize: bpFontSize,
          lineHeight: bpLineHeight,
          padding: getPaddingValues(bpFontSize, bpLineHeight)
        };
      }
    });
  }

  return Object.keys(mediaParamsStyles).length > 0 ? mediaParamsStyles : defaultMediaParamsStyles;
};

exports.responsiveStyles = responsiveStyles;